import { updateRouteSeo } from "@/utils/seo";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createPinia } from "pinia";

const pinia = createPinia();

import "@/assets/font-wrap/index.css";

// element-plus 样式
import "element-plus/dist/index.css";
import elementPlus from "element-plus";

// 国际化
import zhCn from "element-plus/es/locale/lang/zh-cn";

import { ArrowLeft, ArrowLeftBold, ArrowRight, Close, DArrowLeft, Picture, Plus, Promotion, SwitchButton } from "@element-plus/icons-vue";

// 组件
// 自定义组件
import components from "./components/index";
// 自定义组件
import elCustom from "./el-custom/index";

// 加载进度条
import "nprogress/nprogress.css";
import NProgress from "nprogress";

// 配置
NProgress.configure({
  showSpinner: false, //关闭进度环
});

const app = createApp(App);
app
  .use(elementPlus, {
    locale: zhCn,
  })
  .use(store)
  .use(router)
  .use(components)
  .use(elCustom)
  .use(pinia);

// 全局自定义插件方法设置
import * as globalModule from "@/utils/module";
import * as apiConfig from "@/utils/apiConfig";
import * as mainConfig from "@/utils/main";
const globalProperties = {
  ...globalModule,
  ...apiConfig,
  ...mainConfig,
};
for (let i in globalProperties) {
  app.config.globalProperties["$" + i] = globalProperties[i];
}

// 只注册当前模板使用的图标，让构建器移除未使用的图标代码；新增图标时在此同步登记。
const icons = { ArrowLeft, ArrowLeftBold, ArrowRight, Close, DArrowLeft, Picture, Plus, Promotion, SwitchButton };
for (const name in icons) {
  app.component(name, icons[name]);
}

const { initApi } = require("@/utils/http/index");
initApi(store);

// 路由卫士
router.beforeEach((to, from, next) => {
  NProgress.inc();
  next();
});
router.afterEach((to) => {
  updateRouteSeo(to);
  NProgress.done();
});

//等待首次路由及其异步组件就绪，避免先清空静态正文再等待页面组件下载
const staticContent = document.getElementById("app").innerHTML;
router
  .isReady()
  .then(() => {
    app.mount("#app");
    if (window.finishWebsiteStartup) window.finishWebsiteStartup();
  })
  .catch((error) => {
    //首次路由或挂载失败时保留原始可读内容
    document.getElementById("app").innerHTML = staticContent;
    if (window.finishWebsiteStartup) window.finishWebsiteStartup();
    console.error("官网首屏加载失败", error);
  });
